import { PatientPregnant } from '@dreryk/egabinet-patient-medical-information-frontend-api';

import { createInterpolatedTranslationKey, Translate, useTranslate } from '@dreryk/react-common';
import { Heading, SidePanelSlots, StyledFlex, Text } from '@dreryk/react-components';

import { visitPatientPregnancyStatusTranslationKeys } from '../../../translations';

import { GynecologicalInterviewPregnancyBasicInfo } from './GynecologicalInterviewPregnancyBasicInfo';

type GynecologicalInterviewPatientPregnantCategoryContentProps = {
   readonly patientPregnantInterview: PatientPregnant;
};

export const GynecologicalInterviewPatientPregnantCategoryContent = (
   props: GynecologicalInterviewPatientPregnantCategoryContentProps
): JSX.Element => {
   const translate = useTranslate();
   const {
      patientPregnantInterview: {
         pregnancyConfirmed,
         multiplePregnancy,
         predictedCompletionDate,
         predictedCompletionBasis,
         description,
      },
   } = props;
   const predictedCompletionDateDescription = predictedCompletionDate
      ? createInterpolatedTranslationKey(
           visitPatientPregnancyStatusTranslationKeys.visitSidePanelPatientPregnancyDateDescription,
           {
              predictedCompletionDate: predictedCompletionDate,
              predictedCompletionBasis: translate(
                 visitPatientPregnancyStatusTranslationKeys.predictedCompletionDateBasis[predictedCompletionBasis!]
              ),
           }
        )
      : '';
   return (
      <div>
         <Heading
            testId={'patientPregnant'}
            content={visitPatientPregnancyStatusTranslationKeys.patientPregnant}
            type={'h3'}
            bold
         />
         <StyledFlex direction={'column'} gap={'12px'}>
            <StyledFlex direction={'column'} gap={'10px'}>
               <GynecologicalInterviewPregnancyBasicInfo
                  multiplePregnancy={multiplePregnancy ?? false}
                  pregnancyConfirmed={pregnancyConfirmed ?? false}
               />
               {predictedCompletionDate ? (
                  <Text testId={'predictedCompletionDate'} as={'span'}>
                     <Translate>{predictedCompletionDateDescription}</Translate>
                  </Text>
               ) : null}
            </StyledFlex>
            {description ? <SidePanelSlots.Expandable>{description}</SidePanelSlots.Expandable> : null}
         </StyledFlex>
      </div>
   );
};
